<template>
    <div class="material-wrapper">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="800"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!editMode"
                    class="white--text material-button"
                    large
                    :color="'black'"
                    @click="onMaterialChoose"
                    :depressed="editMode">
                    <div v-if="editMode"><v-icon dark>mdi-pencil</v-icon> ΕΠΙΛΟΓΗ ΥΛΙΚΩΝ</div>
                    <div v-else> ΥΛΙΚΑ</div>
                </v-btn>
            </template>
            <v-card>
                <v-card-title class="text-h5">
                    Επιλογή υλικών
                </v-card-title>
                <v-card-text>Καταχωρήστε παρακάτω τα υλικά που χρησιμοποιήθηκαν. Ο περιορισμός του αριθμού των υλικών σημαίνει πως δεν υπάρχει υπόλοιπο διαθέσιμο στην αποθήκη.</v-card-text>
                <div>
                    <v-autocomplete
                        v-model="selectedMaterials"
                        :items="availableMaterials"
                        return-object
                        item-text="name"
                        label="Υλικά"
                        multiple
                        chips
                        class="field autocomplete"
                        @focus="getMaterials()"
                        @change="onMaterialSelect"
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                :key="JSON.stringify(data.item.name)"
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                :disabled="data.disabled"
                                @click:close="data.parent.selectItem(data.item)"
                            >
                                {{ data.item.name }}
                            </v-chip>
                        </template>
                    </v-autocomplete>
                    <v-list lines="one">
                        <v-list-item
                            v-for="material in selectedMaterials"
                            :key="material.id"
                            :title="material"
                            class="list-item-wrapper"
                        >
                            <div class="selected-item-wrapper">
                                <div class="material-label">
                                    <v-icon
                                        large
                                        color="black"
                                    >
                                        mdi-circle-small
                                    </v-icon>
                                    <div class="remainng-material-count">
                                        <h4>{{ material.name }}</h4>
                                        <span>(Διαθ: {{ material.quantity - material.selectedQuantity }})</span>
                                    </div>
                                </div>
                                <div class="material-quantity-wrapper">
                                    <v-btn
                                        class="subsctruction-btn"
                                        outlined
                                        color="red"
                                        small
                                        fab
                                        :disabled="!(material.selectedQuantity + material.alreadyUsedQuantity)"
                                        @click="subtructMaterial(material)"
                                    >
                                        <v-icon>mdi-minus</v-icon>
                                    </v-btn>
                                    <v-text-field
                                        class="quantity-input"
                                        readonly
                                        :value="material.selectedQuantity + material.alreadyUsedQuantity"
                                        :suffix="material.materialMeasurement === 'METERS' ? 'μ' : 'τεμ'"
                                    ></v-text-field>
                                    <v-btn
                                        class="addition-btn"
                                        outlined
                                        color="green"
                                        small
                                        fab
                                        :disabled="material.quantity - material.selectedQuantity === 0 || (material.quantity === 0 && material.selectedQuantity + material.alreadyUsedQuantity > material.alreadyUsedQuantity)"
                                        @click="addMaterial(material)"
                                    >
                                        <v-icon large>mdi-plus</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </v-list-item>
                    </v-list>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="black lighten-2"
                        dark
                        @click="onSubmit"
                    >
                        Υποβολη
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-chip-group
            class="chip-group"
            column
            multiple
        >
            <div
                v-for="material in selectedMaterials"
                :key="material.id"
            >
                <v-chip
                    v-if="material.alreadyUsedQuantity + material.selectedQuantity > 0"
                    dark
                    class="material-chip"
                >
                    <h3 class="mr-1">{{ material.alreadyUsedQuantity + material.selectedQuantity }}</h3> x {{ material.name }}
                </v-chip>
            </div>
        </v-chip-group>
    </div>
</template>
<script>
    import material from '@/services/material'

    export default {
        props: {
            editMode: {
                type: Boolean,
                required: true
            },
            assignmentTab: {
                type: String,
                required: true
            },
            assignment: {
                type: Object,
                required: true
            }
        },
        watch: {
            assignment: {
                handler(val, oldVal) {
                    this.setUsedMaterialsAsSelected(val)
                },
                deep: true
            }
        },
        computed: {
            usedMaterialsMap() {
                let usedMaterialsMap = new Map()
                this.assignment?.materialsUsed?.forEach(usedMaterial => {
                    if (usedMaterial.assignmentTab === this.assignmentTab) {
                        usedMaterialsMap.set(usedMaterial.material.id, usedMaterial)
                    }
                })

                return usedMaterialsMap
            }
        },
        data: () => {
            return {
                availableMaterials: [],
                materialDialog: false,
                selectedMaterials: [],
                dialog: false,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ]
            }
        },
        created() {
            this.getMaterials()
        },
        mounted() {
            this.setUsedMaterialsAsSelected(this.assignment)
        },
        methods: {
            onMaterialChoose() {
                this.getMaterials()
            },
            getMaterials() {
                material.getAvailableMaterials(this.assignment.contractor.id, this.assignmentTab).then(resp => {
                    this.availableMaterials = resp.data
                })
            },
            setUsedMaterialsAsSelected(assignment) {
                this.selectedMaterials = []
                if (assignment.materialsUsed && assignment.materialsUsed.length > 0) {
                    assignment.materialsUsed.forEach(usedMaterial => {
                        if (usedMaterial.assignmentTab === this.assignmentTab) {
                            this.selectedMaterials.push({
                                id: usedMaterial.material.id,
                                name: usedMaterial.material.name,
                                alreadyUsedQuantity: usedMaterial.quantity || 0,
                                quantity: usedMaterial.material.quantity,
                                selectedQuantity: 0 })
                        }
                    })
                }
            },
            addMaterial(material) {
                if (material.quantity - material.selectedQuantity === 0 || (material.quantity === 0 && material.selectedQuantity + material.alreadyUsedQuantity > material.alreadyUsedQuantity)) {
                    return
                }
                material.selectedQuantity++
                this.selectedMaterials = [...this.selectedMaterials]
            },
            subtructMaterial(material) {
                if ((material.selectedQuantity + material.alreadyUsedQuantity) === 0) {
                    return
                }
                material.selectedQuantity--
                this.selectedMaterials = [...this.selectedMaterials]
                if (this.selectedMaterials.length === 0) {
                    this.dialog = false
                }
            },
            onMaterialSelect() {
                this.selectedMaterials.forEach(material => {
                    if (!material.alreadyUsedQuantity) {
                        material.alreadyUsedQuantity = 0
                    }
                    if (!material.selectedQuantity && material.quantity > 0 && !material.alreadyUsedQuantity) {
                        material.selectedQuantity = 1
                    }
                })
            },
            proccessMaterialRequested() {
                let materials = []
                this.usedMaterialsMap.values().forEach(materialFromMap => {
                    const found = this.selectedMaterials.find(material => material.id === materialFromMap.material.id)
                    if (!found) {
                        this.selectedMaterials.push({
                            id: materialFromMap.material.id,
                            selectedQuantity: -materialFromMap.quantity })
                    }
                })
                this.selectedMaterials.forEach(selectedMaterial => {
                    materials.push({ id: selectedMaterial.id, quantity: selectedMaterial.selectedQuantity })
                })
                this.getMaterials()
                this.selectedMaterials = []
                return materials
            },
            onSubmit() {
                this.dialog = false
                this.$emit('materials-selected', this.selectedMaterials)
            }
        }
    }
</script>
<style scoped>
.container {
    width: 100%;
}
.theme--light.v-btn.v-btn--disabled {
  background-color: rgb(0, 0, 0) !important;
  color: white !important;
  opacity: 1 !important;
}

.v-btn {
  border-bottom: 1px solid white !important;
}

.field {
    padding: 0.5rem;
}
.material-chip {
  background-color: #121212 !important;
  color: #ffffff !important;
  border: 2px solid #ffffff !important;
}
.material-quantity-wrapper {
    display: flex;
}

.material-label {
    display: flex;
    align-items: center;
}
.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.selected-item-wrapper {
    display: flex;
}

.field.autocomplete {
    margin: 0 auto;
    max-width: 90%;
}

.material-button {
    width: 100%;
}

.chip-group {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding-right: 1rem;
    padding-left: 1rem;
}

.material-wrapper {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--cards-and-tables-text-color);
    border-radius: 5px;
    margin-bottom: 1rem;
}

.material-quantity-wrapper {
    display: flex;
    justify-content: center;
}

.quantity-input {
    max-width: 100px;
    min-width: 80px;
    text-align: center !important;
}

.remainng-material-count {
    display: flex;
    flex-wrap: wrap;
}

input {
    text-align: center !important;
}

.v-card {
    padding: 0.8rem;
}

.subsctruction-btn {
    align-self: center;
    margin: 0.5rem;
}

.addition-btn {
    align-self: center;
    margin: 0.5rem;
}

.list-item-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
</style>
